/* ------------------------------ */
/* Youtube Video Overlay */

/* ------------------------------ */

window.youTubeOverlay = function youTubeOverlay(youtube_element) {

    $(youtube_element).mtcOverlay({
        contentClass: 'showOverflow',
        video: true,
        videoSettings: {
            autoplay: true,
            width: 800,
            height: 450
        },
        buttonHtml: '<div class="videoCloseButton overlayCloseButton"><a href="#"><i class="fa fa-remove"></i> Close</a></div>'
    });
}

$(document).ready(function () {
   'use strict';

    youTubeOverlay('.videoOverlay');
});